import useSwr, { SWRResponse } from "swr";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { getHQSEligibility } from "services/homeQualificationEligibility";

interface HqsResponse extends SWRResponse<boolean> {
  loading: boolean;
}

const useHqsEligibilityByOpportunityId = (
  opportunityId?: string
): HqsResponse => {
  const shouldFetch = Boolean(opportunityId);
  const result = useSwr(
    shouldFetch ? [opportunityId] : null,
    async ([opportunityId]) => {
      return getHQSEligibility({ opportunityId });
    }
  );
  return { ...result, loading: result.isLoading || result.isValidating };
};

const useHqsEligibilityByProposalId = (proposalId?: string): HqsResponse => {
  const shouldFetch = Boolean(proposalId);
  const result = useSwr(
    shouldFetch ? [proposalId] : null,
    async ([proposalId]) => {
      return getHQSEligibility({ proposalId });
    },
    {
      shouldRetryOnError: false,
    }
  );
  return { ...result, loading: result.isLoading || result.isValidating };
};

const useHqsUrl = ({
  prospectId,
  earlyCapture = false,
}: {
  prospectId: string | undefined;
  earlyCapture?: boolean;
}) => {
  if (!prospectId) {
    return "";
  }
  const env = getEnvironment();
  const hqsPrdUrl = `https://www.home-qualification-survey.designtools.sunrun.com/prospect/${prospectId}`;
  const hqsStagingUrl = `https://www.home-qualification-survey.devdesigntools.sunrun.com/prospect/${prospectId}`;
  const baseUrl = env === "production" ? hqsPrdUrl : hqsStagingUrl;
  return earlyCapture ? `${baseUrl}?EarlyCapture` : baseUrl;
};

export {
  useHqsEligibilityByOpportunityId,
  useHqsEligibilityByProposalId,
  useHqsUrl,
};
